import ajax from '@/utils/ajax';

const header = '/web';
// 获取推荐产品接口（产品详情页-满减）
// eslint-disable-next-line import/prefer-default-export
export const reqProductRecommend = (data) => ajax(`${header}/v1/promotion/full/recommend/page`, data, 'POST');
